/**
 * Coalesce concurrent async work by key for the current Nuxt app instance.
 * Promises must not go in useState — they cannot be serialized into the SSR payload.
 */
const buckets = new WeakMap<object, Map<string, Promise<unknown>>>()

export function useInflight<T = void>(key: string) {
  const app = useNuxtApp()
  let map = buckets.get(app)
  if (!map) {
    map = new Map()
    buckets.set(app, map)
  }

  async function run(job: () => Promise<T>): Promise<T> {
    const existing = map.get(key)
    if (existing) return existing as Promise<T>
    const pending: Promise<T> = job().finally(() => {
      if (map.get(key) === pending) map.delete(key)
    })
    map.set(key, pending)
    return pending
  }

  return { run }
}
